import { render, staticRenderFns } from "./CommunicationSuccessRate.vue?vue&type=template&id=dd27fbd2&scoped=true&"
import script from "./CommunicationSuccessRate.vue?vue&type=script&lang=js&"
export * from "./CommunicationSuccessRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd27fbd2",
  null
  
)

export default component.exports